import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from 'firebase/firestore'
import {getAuth, signInWithCustomToken, signOut as sOut} from 'firebase/auth'

const firebaseConfig = /*{
   apiKey: "AIzaSyB5lzpaicY7cFqdP7LsywMaCN7BNn7djAo",
   authDomain: "auftragsbuchchat.firebaseapp.com",
   projectId: "auftragsbuchchat",
   storageBucket: "auftragsbuchchat.appspot.com",
   messagingSenderId: "970010372089",
   appId: "1:970010372089:web:ee970ea7a6e71526097f28",
   measurementId: "G-04GZ88S4HZ"
};*/
{apiKey: "AIzaSyAnY9JAPGSg80h_p-IGrMp6E8slsVy5a3w",
    authDomain: "auftragsbuchchat.firebaseapp.com",
    projectId: "auftragsbuchchat",
    storageBucket: "auftragsbuchchat.appspot.com",
    messagingSenderId: "970010372089",
    appId: "1:970010372089:web:619bd8d801ebf77a097f28",
    measurementId: "G-W1L1QDXP5Z"};

export function signIn(customToken) {
    initializeApp(firebaseConfig)
    let firebaseAuth = getAuth();
    return signInWithCustomToken(firebaseAuth, customToken)
}

export function signOut() {
    initializeApp(firebaseConfig)
    let firebaseAuth = getAuth();
    return sOut(firebaseAuth)
}

export function setToken(userId) {
    initializeApp(firebaseConfig)
    class Notification {
        static permission = 'granted';
        static maxActions = 2;
        static name = 'Notification';
        constructor(title, options) {
            console.log(title);
            let packageSet = new Set();
            packageSet.add(title).add(options);
            let json_package = JSON.stringify([...packageSet]);
            alert(title);
        }
        static requestPermission() {
            return new Promise((res, rej) => {
                res('granted');
            })
        }
    };
    window.Notification = Notification;
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: 'BL9RdW_4sgjX8vuKb1d8ROENZbjiBFy2Zp9QTKfgZXe6erQo9lZ398HvRnjlgCcvm-nFoph760L-4bt2yzphbps' }).then((currentToken) => {
        if (currentToken) {
            console.log("curent token: " + currentToken)
            // todo send to server
            console.log("start listening")
            onMessage(messaging, (payload) => {
                console.log('Message received. ', payload);
            });
        } else {
            // Show permission request UI
            console.log('No registration token available. Request permission to generate one.');
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
}
